import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col} from "react-bootstrap";
import Select from 'react-select';
import {LabelFieldComponent, LabelTextareaComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components"; 
import PageLayout from "../../layouts/PageLayout";
import { toast } from 'react-toastify';
import { useParams, useSearchParams } from "react-router-dom";
import { createUser, showUser, updateUser, listAllUsers } from "../../APIs/UserRequests";
import { listRoles } from "../../APIs/RoleRequests";
import { getAllCities, getAllCountries, getAllStates, getSettings } from "../../APIs/SettingRequests";
import { listUserTypes } from "../../APIs/UserTypeRequests";
export default function MyAccountPage() {
    const {id} = useParams();


    const { t } = useContext(TranslatorContext);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [bio, setBio] = useState('');
    const [status, setStatus] = useState('active');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [created_at, setCreated_at] = useState('');
    const [role, setRole] = useState(2);
    const [type, setType] = useState('company');
    const [image, setImage] = useState('');
    const [roles, setRoles] = React.useState([]);
    const [imagePreview, setImagePreview] = useState('');
    const [title, setTitle] = useState('');
    const [parentId, setParentId] = useState(null);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0); // Add force update state
    const [userTypes, setUserTypes] = useState([]);
    const [userTypeId, setUserTypeId] = useState(null);

    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);

    const [country, setCountry] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');

    const [selectedCountryId, setSelectedCountryId] = useState(null);
    const [selectedCityId, setSelectedCityId] = useState(null);
    const [selectedStateId, setSelectedStateId] = useState(null);

    const [defaultCountry, setDefaultCountry] = React.useState('');

    

    const getSettingCountriesAction = () => {
        getAllCountries(1,500).then((res) => {
            setCountries(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    const listSettingsFunction = (page=1) => {
        getSettings().then((res) => {
            const defaultCountrySetting = res.data.data.find(setting => setting.key === 'default_country');
            if (defaultCountrySetting) {
                setDefaultCountry(parseInt(defaultCountrySetting.value));
                setSelectedCountryId(parseInt(defaultCountrySetting.value));
                getSettingCitiesAction(parseInt(defaultCountrySetting.value));
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const getSettingCitiesAction = (defaultCountry) => {
        getAllCities(defaultCountry,1,500).then((res) => {
            setCities(res.data.data);
            setSelectedCityId(res.data.data[0]?.id || null);
            getSettingStatesAction(res.data.data[0]?.id || null);
        }).catch((error) => {
        });
    }

    const getSettingStatesAction = (city_id) => {
        getAllStates(city_id,1,500).then((res) => {
            setStates(res.data.data);
            setSelectedStateId(res.data.data[0]?.id || null);
        }).catch((error) => {
        });
    }

    useEffect(()=> {
        if(id){
            showUserFunction();
        } else {
            listUserTypesFunction();
        }
        getSettingCountriesAction();
        listSettingsFunction();
    },[id]);

    useEffect(() => {
        if (id && userTypeId) {
            listUserTypesFunction();
            loadParentUsers();
        }
    }, [userTypeId]);

    const showUserFunction = () => {
        showUser(id).then((res)=> {
            const userData = res.data.data;
            
            setName(userData.name);
            setEmail(userData.email);
            setBio(userData.bio);
            setStatus(userData.status ? 'active' : 'inactive');
            setPhone(userData.phone);
            setAddress(userData.address);
            setCreated_at(userData.created_at);
            setRole(userData.role);
            setType(userData.type??null);
            setImage(userData.image);
            setImagePreview(userData.image);
            setCountry(userData.country);
            setCity(userData.city);
            setState(userData.state);
            setTitle(userData.title);
            setParentId(userData.parent_id);
            
            if (userData.user_type_id) {
                setUserTypeId(userData.user_type_id);
            }
            
            if (userData.city_id) {
                setSelectedCityId(userData.city_id);
                getSettingStatesAction(userData.city_id);
            }
            if (userData.state_id) {
                setSelectedStateId(userData.state_id);
            }
            if (userData.country_id) {
                setSelectedCountryId(userData.country_id);
            }
            
            listUserTypes(1, 1000).then((userTypesRes) => {
                const userTypesData = userTypesRes.data.data || [];
                setUserTypes(userTypesData);
                
                const currentUserType = userTypesData.find(ut => ut.id === userData.user_type_id);
                if (currentUserType) {
                    loadParentUsersForUserType(currentUserType.superior_id);
                }
            }).catch((error) => {
            });
            
        }).catch((error) => {
        });
    }

    const loadParentUsers = () => {
        if (userTypeId) {
            const currentUserType = userTypes.find(ut => ut.id === userTypeId);
            if (currentUserType) {
                loadParentUsersForUserType(currentUserType.superior_id);
            }
        }
    }

    const loadParentUsersForUserType = (superiorUserTypeId) => {
        let apiCall;
        
        if (superiorUserTypeId) {
            apiCall = listAllUsers(1, 1000, '', superiorUserTypeId);
        } else {
            apiCall = listAllUsers(1, 1000);
        }
        
        apiCall.then((res) => {
            const allUsers = res.data.data || [];
            const filteredUsers = id ? allUsers.filter(user => user.id != id) : allUsers;
            setUsers(filteredUsers);
        }).catch((error) => {
            console.log('Error loading users:', error);
        });
    }

    const updateUserFunction = () => {
        setLoading(true);
        let statusOption = status == 'active' ? 1 : 0;
        let bioOption= bio == '' ? null: bio;
        let phoneOption =  phone == ''? null:phone;
        let setAddressOption = address == ''? null:address;

        const formData = new FormData();

        formData.append('name', name);
        formData.append('email', email);
        formData.append('bio', bioOption);
        formData.append('status', statusOption);
        formData.append('phone', phoneOption);
        formData.append('address', setAddressOption);
        formData.append('role_id', role);
        if (image instanceof File) {
            formData.append('image', image);
        }
        if (type) {
            formData.append('type', type);
        }
        formData.append('country_id', selectedCountryId);
        formData.append('city_id', selectedCityId);
        formData.append('state_id', selectedStateId);
        formData.append('title', title);
        if(parentId){
            formData.append('parent_id', parentId);
        }
        if(userTypeId){
            formData.append('user_type_id', userTypeId);
        }
        updateUser(
            id,
            formData
        ).then((res)=> {
            const notify = () => toast.success(res.data.message);
            notify();
            setTimeout(() => {
                window.location.href = '/users-management';
            }, 2000);
           
        }).catch((error) => {
            console.error('Error updating user:', error);
            toast.error(t('error_updating_user'));
        }).finally(() => {
            setLoading(false);
        });
    }

    const createUserFunction = () => {
        setLoading(true);
        let statusOption = status == 'active' ? 1 : 0;
        let bioOption= bio == '' ? null: bio;
        let phoneOption =  phone == ''? null:phone;
        let setAddressOption = address == ''? null:address;

        const formData = new FormData();

        formData.append('name', name);
        formData.append('email', email);
        formData.append('bio', bioOption);
        formData.append('status', statusOption);
        formData.append('phone', phoneOption);
        formData.append('address', setAddressOption);
        formData.append('role_id', role);
        if (image instanceof File) {
            formData.append('image', image);
        }
        formData.append('type', type);
        formData.append('country_id', selectedCountryId);
        formData.append('city_id', selectedCityId);
        formData.append('state_id', selectedStateId);
        formData.append('title', title);
        if(parentId){
            formData.append('parent_id', parentId);
        }
        if(userTypeId){
            formData.append('user_type_id', userTypeId);
        }
        createUser(
            formData
        ).then((res)=> {
            const notify = () => toast.success(res.data.message);
            notify();
            setTimeout(() => {
                window.location.href = '/users-management';
            }, 2000);
           
        }).catch((error) => {
            console.error('Error creating user:', error);
            toast.error(t('error_creating_user'));
        }).finally(() => {
            setLoading(false);
        });
    }

    const [userTypeError, setUserTypeError] = useState('');
    const [nameError, setNameError] = useState('');
    const [bioError, setBioError] = useState('');
    const [cityError, setCityError] = useState('');
    const [stateError, setStateError] = useState('');
    const [emailError, setEmailError] = useState('');

    const handleClickAction = () => {
        let hasError = false;
        
        // Clear previous errors
        setNameError('');
        setBioError('');
        setUserTypeError('');
        setCityError('');
        setStateError('');
        setEmailError('');

        // Validate name (required)
        if (!name || name.trim() === '') {
            setNameError(t('name_required') || 'Name is required');
            hasError = true;
        }

        // Validate email (required and format)
        if (!email || email.trim() === '') {
            setEmailError(t('email_required') || 'Email is required');
            hasError = true;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
            setEmailError(t('email_invalid') || 'Please enter a valid email address');
            hasError = true;
        }

        if (!userTypeId) {
            setUserTypeError(t('user_type_required') || 'User type is required');
            hasError = true;
        }

        if (!selectedCityId) {
            setCityError(t('city_required') || 'City is required');
            hasError = true;
        }

        if (!selectedStateId) {
            setStateError(t('state_required') || 'State is required');
            hasError = true;
        }

        if (hasError) {
            return;
        }

        if(id){
            updateUserFunction();
        }else{
            createUserFunction();
        }
    }

    const handleNameChange = (e) => {
        setName(e.target.value);
        if (nameError) {
            setNameError('');
        }
    }

    const handleBioChange = (e) => {
        setBio(e.target.value);
        if (bioError) {
            setBioError('');
        }
    }

    const handleUserTypeChange = (e) => {
        setUserTypeError('');
        
        const selectedUserTypeId = e.target.value;
        
        if (selectedUserTypeId === '' || selectedUserTypeId === null) {
            setUserTypeId(null);
            setParentId(null);
            setUsers([]);
        } else {
            const selectedUserType = userTypes.find(ut => ut.id == selectedUserTypeId);
            setUserTypeId(selectedUserType ? selectedUserType.id : null);
            setParentId(null); 
            
            if (selectedUserType) {
                listUsersFunction(selectedUserType.superior_id);
            }
        }
    }

    const handleCityChange = (selectedOption) => {
        setSelectedCityId(selectedOption.value);
        setCityError('');
        getSettingStatesAction(selectedOption.value);
        setSelectedStateId(null);
        setStateError('');
    }

    const handleStateChange = (selectedOption) => {
        setSelectedStateId(selectedOption.value);
        setStateError('');
    }

    const listUsersFunction = (userTypeFilter = null) => {
        let apiCall;
        
        if (userTypeFilter) {
            apiCall = listAllUsers(1, 1000, '', userTypeFilter);
        } else {
            apiCall = listAllUsers(1, 1000);
        }
        
        apiCall.then((res) => {
            const allUsers = res.data.data || [];
            const filteredUsers = id ? allUsers.filter(user => user.id != id) : allUsers;
            setUsers(filteredUsers);
            
            if (!id && filteredUsers.length > 0) {
                setParentId(filteredUsers[0]?.id || null);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const listUserTypesFunction = () => {
        listUserTypes(1, 1000).then((res) => {
            const userTypesData = res.data.data || [];
            setUserTypes(userTypesData);
            
            if (!id) {
                setUserTypeId(userTypesData[0]?.id || null);
                if (userTypesData[0]) {
                    listUsersFunction(userTypesData[0].superior_id || null);
                }
            }
        }).catch((error) => {
            console.log(error);
        });
    }


    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            {
                                id ? <h3 className="mc-breadcrumb-title">{name}</h3>:<h3 className="mc-breadcrumb-title">{t('create_user')}</h3>
                            }
                        </div>
                    </div>
                </Col>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-tab-card">
                            <h6 className="mc-tab-card-title">{t('public_information')}</h6>
                            <Row>
                                <Col xl={4}>
                                    <div className="mc-user-avatar-upload">
                                        <div className="mc-user-avatar">
                                            <img src={imagePreview===''?"/images/avatar/profile.jpg":imagePreview} alt={t('avatar') || 'avatar'} />
                                        </div>
                                        <FileUploadComponent icon="cloud_upload" text={t('upload')} onChange={(e)=>{
                                            const file = e.target.files?.[0];
                                            
                                            // Validate file size (5MB = 5 * 1024 * 1024 bytes)
                                            const maxSize = 5 * 1024 * 1024; // 5MB in bytes
                                            
                                            if (file && file.size > maxSize) {
                                                toast.error(t('image_size_error') || 'Image size must be less than 5MB');
                                                // Clear the file input
                                                e.target.value = '';
                                                return;
                                            }
                                            
                                            setImage(file);
                                            if (file) {
                                                const reader = new FileReader();
                                                reader.onloadend = () => {
                                                    setImagePreview(reader.result);
                                                };
                                                reader.readAsDataURL(file);
                                            } else {
                                                setImagePreview(null);
                                            }
                                        }}/>
                                    </div>
                                </Col>
                                <Col xl={8}>
                                    <Row>
                                        <Col xl={12}>
                                            <LabelFieldComponent 
                                                type="text" 
                                                label={t('fullname')} 
                                                fieldSize="w-100 h-md" 
                                                onChange={handleNameChange} 
                                                value={name}
                                                required={true}
                                                error={nameError}
                                            />
                                            {nameError && (
                                                <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                    {nameError}
                                                </div>
                                            )}
                                        </Col>
                                        
                                        <Col xl={12}>
                                            <LabelTextareaComponent 
                                                label={t('biography')} 
                                                fieldSize="w-100 h-3xl" 
                                                value={bio} 
                                                onChange={handleBioChange}
                                                error={bioError}
                                            />
                                            {bioError && (
                                                <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                    {bioError}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        
                        <div className="mc-tab-card">
                            <h6 className="mc-tab-card-title">{t('private_information')}</h6>
                            <Row>
                                <Col xl={6}><LabelFieldComponent label={t('status')}  fieldSize="w-100 h-md" option={[
                                    {id: 'active', name: t('active')},
                                    {id: 'inactive', name: t('inactive')}
                                ]} value={status} onChange={(e)=> setStatus(e.target.value)}/></Col>
                                {
                                    parseInt(role) === 4 &&
                                    <Col xl={6}><LabelFieldComponent label={t('permission to add contract')}  fieldSize="w-100 h-md" option={[t('company'), t('individual'), t('both')]} value={type} onChange={(e)=> setType(e.target.value)}/></Col>

                                }
                                <Col xl={6}><LabelFieldComponent type="email" label={t('email')}  fieldSize="w-100 h-md" value={email} onChange={(e)=> setEmail(e.target.value)} required={true} errorMessage={emailError}/></Col>
                             

                                <Col xl={6}><LabelFieldComponent maxlength={12} type="tel" label={t('phone')}  fieldSize="w-100 h-md" value={phone} onChange={(e)=> setPhone(e.target.value)}/></Col>
                                {
                                    id && 
                                    <Col xl={6}><LabelFieldComponent type="disabled" label={t('creation date')}  fieldSize="w-100 h-md" value={created_at} disabled/></Col>

                                }

                          
                                <Col xl={6}><LabelFieldComponent type="text" label={t('title')}  fieldSize="w-100 h-md" value={title} onChange={(e)=> setTitle(e.target.value)}/></Col>

                                <Col xl={6}>
                                    <LabelFieldComponent 
                                        label={t('user_type') || 'User Type'} 
                                        fieldSize="w-100 h-md" 
                                        option={userTypes.map(userType => ({ id: userType.id, name: userType.name }))} 
                                        value={userTypeId} 
                                        onChange={handleUserTypeChange}
                                        placeholder={t('select_user_type') || 'Select User Type'}
                                        required={true}
                                        error={userTypeError}
                                    />
                                    {userTypeError && (
                                        <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                            {userTypeError}
                                        </div>
                                    )}
                                </Col>

                                <Col xl={6}>
                                    <LabelFieldComponent 
                                        label={t('parent_user')} 
                                        fieldSize="w-100 h-md" 
                                        option={users.map(user => ({ id: user.id, name: user.name }))} 
                                        value={parentId} 
                                        onChange={(e) => {
                                            setParentId(e.target.value)
                                        }}
                                        placeholder={userTypeId ? t('select_parent_user') : t('select_user_type_first') || 'Select user type first'}
                                        disabled={!userTypeId} 
                                    />
                                </Col>
                                
                                <Col xl={12}><LabelTextareaComponent label={t('address')} fieldSize="w-100 h-5xl" value={address} onChange={(e)=> setAddress(e.target.value)}/></Col>
                                
                                <Col xl={12} className="mb-4" style={{ marginTop: '20px' }}>
                                    <h6 className="mc-tab-card-title">{t('country')}</h6>
                                    <Select
                                        value={{ value: defaultCountry, label: countries.find(country => country.id === defaultCountry)?.name }}
                                        placeholder={t('select_country')}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        isDisabled={true}
                                        
                                    />
                                </Col>

                                <Col xl={12} className="mb-4">
                                    <div className="form-group">
                                        <h6 className="mc-tab-card-title">
                                            {t('city')} <span style={{ color: '#dc3545' }}>*</span>
                                        </h6>
                                        <Select
                                            options={cities.map(city => ({ value: city.id, label: city.name }))}
                                            value={selectedCityId ? { value: selectedCityId, label: cities.find(c => c.id === selectedCityId)?.name } : null}
                                            placeholder={t('select_city')}
                                            className={`basic-multi-select ${cityError ? 'is-invalid' : ''}`}
                                            classNamePrefix="select"
                                            onChange={handleCityChange}
                                        />
                                        {cityError && (
                                            <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                {cityError}
                                            </div>
                                        )}
                                    </div>
                                </Col>

                                <Col xl={12} className="mb-4">
                                    <div className="form-group">
                                        <h6 className="mc-tab-card-title">
                                            {t('state')} <span style={{ color: '#dc3545' }}>*</span>
                                        </h6>
                                        <Select
                                            options={states.map(state => ({ value: state.id, label: state.name }))}
                                            value={selectedStateId ? { value: selectedStateId, label: states.find(s => s.id === selectedStateId)?.name } : null}
                                            placeholder={t('select_state')}
                                            className={`basic-multi-select ${stateError ? 'is-invalid' : ''}`}
                                            classNamePrefix="select"
                                            onChange={handleStateChange}
                                        />
                                        {stateError && (
                                            <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                                                {stateError}
                                            </div>
                                        )}
                                    </div>
                                </Col>
                                
                            </Row>
                        </div>
                        
                        <ButtonComponent 
                            className={`mc-btn primary ${loading ? 'loading' : ''}`} 
                            icon={loading ? "hourglass_empty" : "verified"} 
                            text={loading ? t('loading') : (id ? t('save_changes') : t('create_new'))} 
                            onClick={() => handleClickAction()}
                            disabled={loading}
                        />
                          
                    </div>
                </Col>
            </Row>
        </PageLayout>
    )
}